import { Box, CircularProgress } from "@mui/material";
import './Loader.css';

export const Loader = () => {
    return (
        <Box className="loader_cls" >
            <CircularProgress color="inherit" />
        </Box>
    )
}
